import React, { Component } from "react"
import { Helmet } from "react-helmet-async"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import { connect } from "react-redux"
import CookieConsent from "react-cookie-consent"
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles"

import { toggleDarkMode } from "../../state/actions"
import { Nav } from "../Nav"
import { SideContext } from "../SideContext"

import useSiteMetadata from "../SiteMetadata"
import { ArchieTheme } from "../theme"

import "../../styles/main.scss"
import "./Layout.scss"


const theme = createMuiTheme(ArchieTheme)


export class TemplateWrapper extends Component {

  constructor(props) {
    super(props)
    this.state = {
      navOpen: true
    }
  }

  render() {
    const { title, description, siteUrl, fbAppId } = useSiteMetadata()
    const { asScreen, showNav, showClouds, darkMode, forceLight, children } = this.props
    const { navOpen } = this.state

    let navClass
    if (showNav) {
      navClass = (navOpen ? "nav-open" : "nav-closed")
    } else {
      navClass = "side-context"
    }

    let showDark = forceLight ? false : darkMode

    return (
      <div className={`layout ${showDark ? "dark" : "light"}`}>
        <Helmet>
          <html lang="en" />
          <title>{title}</title>
          <meta property="fb:app_id" content={fbAppId}/>
          <meta name="description" content={description}/>
          <meta property="og:description" content={description}/>
          <meta property="og:type" content="website"/>
          <meta property="og:title" content={title}/>
          <meta property="og:url" content={`${siteUrl}/`}/>
          <meta property="og:image" content={`${siteUrl}/img/og-image.png`}/>
          <meta property="og:image:height" content="2953"/>
          <meta property="og:image:width" content="3543"/>

          <meta name="theme-color" content="#fff" />

          <link rel="preconnect dns-prefetch" href="https://fonts.googleapis.com" crossOrigin/>
          <link rel="preconnect dns-prefetch" href="https://fonts.gstatic.com" crossOrigin/>
          <link rel="preconnect dns-prefetch" href="https://connect.facebook.net" crossOrigin/>
          <link rel="preconnect dns-prefetch" href="https://www.facebook.com" crossOrigin/>
          <script async src="https://w.appzi.io/w.js?token=EyDf7"></script>
        </Helmet>

        <ThemeProvider theme={theme}>
          {showNav ?
            <Nav
              onToggle={(state) => {this.setState({navOpen: state.open})}}
              onToggleDarkMode={this.props.toggleDarkMode}
              darkMode={this.props.darkMode}
            />
            :
            <SideContext/>
          }

          <div className={
            `page-content page-content--${navClass}
             ${showClouds ? "page-content--with-footer" : ""}`
          }>
            <div className={`content ${asScreen ? "content--screen" : ""}`}>
              {children}
            </div>
          </div>

          {showClouds ?
            <div className="cloud-footer">
              <div className="cloud-footer__content">
                Cloudbuddies © {(new Date().getFullYear())}
              </div>
            </div> :
            ""
          }
          <CookieConsent
            style={
              {
                color: "#222222",
                backgroundColor: "#ffffff",
                borderTop: "solid 1px #f0f0f0",
                boxShadow: "0 -3px 3px rgba(34, 34, 34, 0.25)",
                zIndex: 2000,
              }
            }
            buttonStyle={
              {
                backgroundColor: "#01bfd8",
                color: "#ffffff",
                fontSize: "16px",
                padding: "10px 15px"
              }
            }
            buttonText="I Understand"
          >
            Archie uses cookies to help us improve your experience.
            Check our <Link to="/privacy" className="link">Privacy Policy</Link> for more info.
          </CookieConsent>
        </ThemeProvider>
      </div>
    )
  }
}


TemplateWrapper.propTypes = {
  children: PropTypes.node,
  showClouds: PropTypes.bool,
  darkMode: PropTypes.bool,
  showNav: PropTypes.bool,
  asScreen: PropTypes.bool,
  toggleDarkMode: PropTypes.func,
  showDark: PropTypes.bool,
  forceLight: PropTypes.bool,
}

TemplateWrapper.defaultProps = {
  showClouds: false,
  darkMode: true,
  showNav: true,
  asScreen: false,
  forceLight: false,
}

const mapStateToProps = state => ({
  darkMode: state.darkMode.darkMode
})


const mapDispatchToProps = dispatch => ({
  toggleDarkMode: () => dispatch(toggleDarkMode())
})


export default connect(mapStateToProps, mapDispatchToProps)(TemplateWrapper)
